/* eslint-disable no-cstyle-for-loop/noForLoop */
// produces sparse array
export const replaceSubarray = (oldArray, newArray, replaceFrom, _replaceTo) => {
    const replaceTo = Math.max(replaceFrom, _replaceTo);
    const minLength = Math.max(replaceFrom + newArray.length, oldArray.length - Math.max(0, replaceTo - replaceFrom) + newArray.length);
    const out = Array(minLength);
    // 1. get first part of old array
    for (let i = 0; i < Math.min(replaceFrom, oldArray.length); i++) {
        // eslint-disable-next-line no-prototype-builtins
        if (oldArray.hasOwnProperty(i)) {
            out[i] = oldArray[i];
        }
    }
    // 2. add elements of new array
    for (let i = 0; i < newArray.length; i++) {
        // eslint-disable-next-line no-prototype-builtins
        if (newArray.hasOwnProperty(i)) {
            out[replaceFrom + i] = newArray[i];
        }
    }
    const start = replaceFrom + newArray.length;
    for (let i = 0; i < oldArray.length - replaceTo; i++) {
        // eslint-disable-next-line no-prototype-builtins
        if (oldArray.hasOwnProperty(replaceTo + i)) {
            out[start + i] = oldArray[replaceTo + i];
        }
    }
    return out;
};
//# sourceMappingURL=replaceSubarray.js.map